<template>
    <div>
        <!--d-none d-lg-block-->
        <v-data-table class="my-5 rounded bordered taabel" v-model:expanded="tabel.laiendatud"
            :headers="tabel.paised" :items="elemendid" :items-per-page="tabel.lehePikkus" :loading="tabel.laeb"
            show-expand fixed-header single-expand item-key="id">
            <template #expanded-row="{ columns, item }">
                <tr>
                    <td :colspan="columns.length">
                        <AjakavaRidaTabel :elemendid="(item.ajakavaList as any)"></AjakavaRidaTabel>
                    </td>
                </tr>
            </template>
            <template v-slot:bottom> </template>
        </v-data-table>        
        <v-data-iterator class="d-none d-lg-none" :items="elemendid" item-value="id">
            <template v-slot:default="{ items }">
                <v-row>
                    <v-col class="w-100" cols="auto" v-for="item in items" :key="item.raw.id">
                        <v-card class="mx-auto">
                            <template v-slot:title>
                                Ajakava nr.: {{ item.raw.id }}
                            </template>
                            <template v-slot:prepend>
                                <v-btn v-if="aluseId && broneeringuId && ajakavaId"
                                    @click="$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [aluseId.toString(), broneeringuId.toString()] } });"
                                    icon="mdi-chevron-left"></v-btn>
                            </template>
                            <template v-slot:append>
                                <v-btn v-if="aluseId && broneeringuId && !ajakavaId"
                                    @click="$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [aluseId.toString(), broneeringuId.toString(), item.raw.id] } });"
                                    icon="mdi-chevron-right"></v-btn>
                            </template>
                            <v-expansion-panels>
                                <v-expansion-panel :title="item.raw.tookohaNimetus">
                                    <v-expansion-panel-text>
                                        <v-list :lines="false" density="compact">
                                            <v-list-item :title="item.raw.tegemiseKoht">
                                                <template v-slot:title="{ title }">
                                                    <b>ÜKT tegemise koht:</b> {{ title }}
                                                </template></v-list-item>
                                            <v-list-item :title="item.raw.juhendajaAndmed">
                                                <template v-slot:title="{ title }">
                                                    <div class="d-flex flex-row">
                                                        <v-sheet class="mr-2"><b>Juhendaja andmed:</b></v-sheet>
                                                        <v-sheet>
                                                            <p v-for="(andmed, i) in title" :key="i"> {{ andmed }}</p>
                                                        </v-sheet>
                                                    </div>
                                                </template></v-list-item>
                                        </v-list>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
        </v-data-iterator>
    </div>
</template>
<script lang="ts">
import { TegevuseAjakavaListItem } from '@/models/UldkasulikToo';
import AjakavaRidaTabel from './AjakavaRidaTabel.vue';
import { PropType, defineComponent } from 'vue';
import mixin from '@/core/mixins';

export default defineComponent({
    name: 'AjakavaTabel',
    components: { AjakavaRidaTabel },
    mixins: [mixin],
    data() {
        return {
            tabel: {
                laiendatud: [] as Array<any>,
                paised: [
                    {
                        title: '',
                        key: 'data-table-expand',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        }
                    },
                    {
                        title: 'Ajakava nr.',
                        sortable: false,
                        key: 'id',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'Ajakava periood',
                        sortable: false,
                        key: 'nimetus',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                ],
                laeb: false,
                lehePikkus: -1
            },
        }
    },
    props: {
        elemendid: Array as PropType<Array<TegevuseAjakavaListItem>>,
        aluseId: Number as PropType<Number>,
        broneeringuId: Number as PropType<Number>,
        ajakavaId: Number as PropType<Number>,
    },
    watch: {       
        ajakavaId: {
            handler: function () {
                this.uuendaLaiendatud();
            },
            deep: true
        },
    },
    mounted: function () {
        this.uuendaLaiendatud();
    },
    methods: {
        uuendaLaiendatud() {
            this.tabel.laiendatud = [];
            if (this.ajakavaId) this.tabel.laiendatud.push(this.ajakavaId);
        },
    }
});
</script>

<style scoped>
.taabel {
    background-color: var(--varv-taust-1);
}

.bordered {
    border: 1px solid var(--varv-lisa-3);
}
</style>